import { jwtKeyName } from '@session/getJwt';

export function clearSession() {
  localStorage.removeItem(jwtKeyName);
}
